import styled from 'styled-components';

export const PopoverCard = styled.div`
  border-radius: var(--border-radius-medium);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: var(--color-bg-popup);
  border: 1px solid var(--color-border);
  overflow: hidden; /* 裁剪超出圆角边界的内容 */
`;
